import { CSSProperties, useEffect, useState } from 'react';
import { Size } from '@vivli/shared/theme';
import { TabComponent, TabsComponent } from '@vivli/shared/components';
import { useDataRequestContext } from '@vivli/features/data-requests/infrastructure/context';
import { useActiveUserContext } from '@vivli/core/infrastructure/context';
import { NotificationFeature } from '@vivli/shared/features/notification/feature';
import { useNotificationContext } from '@vivli/shared/features/notification/infrastructure/context';
import { ButtonView } from '@vivli/shared/views';
import { PermissionsEnum } from '@vivli/shared/infrastructure/enum';

const containerStyle: CSSProperties = {
    margin: `0 ${Size.INSET_SIZE}px`,
    height: '100%'
};
const buttonContainerStyle: CSSProperties = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '15px'
};

const tabButtonsStyle: CSSProperties = {
    display: 'flex',
    gap: '10px',
    height: '100%',
    position: 'absolute',
    right: '30px'
};

interface IStatusUpdateTab {
    name: string;
    sortOrder: number;
    title: string;
}

enum TabTitleEnum {
    notification = 'Notifications'
}

enum TabRouteEnum {
    notification = 'Notifications'
}

export const DataRequestNotificationsSubTabComponent = () => {
    const { dataRequest } = useDataRequestContext();
    const { resetNotificationForm, handleSubmit, notifications, isSaving, isFormValid, isFormDirty } = useNotificationContext();
    const { hasPermission } = useActiveUserContext();

    const getTabs = () => {
        const defaultTabs: IStatusUpdateTab[] = [
            {
                name: TabRouteEnum.notification,
                sortOrder: 0,
                title: TabTitleEnum.notification
            }
        ];
        return defaultTabs.sort((a, b) => a.sortOrder - b.sortOrder);
    };

    const [tabs, setTabs] = useState<IStatusUpdateTab[]>();
    const [activeTab, setActiveTab] = useState('');
    const handleTabClick = (tab: IStatusUpdateTab) => {
        setActiveTab(tab.name);
    };

    useEffect(() => {
        //TODO PERMFE - redo with permissions+
        if (hasPermission(PermissionsEnum.DrActAdv)) {
            setTabs(getTabs());
        } else {
            setTabs([getTabs()[0]]);
        }
    }, []);

    useEffect(() => {
        if (tabs !== undefined) setActiveTab(tabs[0].name);
    }, [tabs]);

    const buttonsDisplayed = (activeTab) => {
        switch (activeTab) {
            case 'Notifications':
                return (
                    <>
                        <div style={buttonContainerStyle}>
                            {notifications[0] && (
                                <ButtonView style={{ maxWidth: '200px' }} onClick={resetNotificationForm}>
                                    {'Create New Notification'}
                                </ButtonView>
                            )}
                            <ButtonView
                                style={{ maxWidth: '200px' }}
                                disabled={!isFormValid || !isFormDirty || isSaving}
                                isLoading={isSaving}
                                onClick={handleSubmit}
                            >
                                {'Save Notification'}
                            </ButtonView>
                        </div>
                    </>
                );
            default:
                return null;
        }
    };
    const tabDisplayed = (activeTab) => {
        switch (activeTab) {
            case 'Notifications':
                return <NotificationFeature topicId={dataRequest.id} />;
            default:
                return null;
        }
    };

    return (
        <div style={containerStyle}>
            <div style={containerStyle}>
                <TabsComponent defaultTab={0}>
                    {tabs?.map((tab, i) => {
                        const { title } = tab;
                        return (
                            <TabComponent
                                key={i}
                                title={title}
                                onTabClick={() => handleTabClick(tab)}
                                rightHeaderContent={<div style={tabButtonsStyle}>{buttonsDisplayed(activeTab)}</div>}
                            >
                                {tabDisplayed(activeTab)}
                            </TabComponent>
                        );
                    })}
                </TabsComponent>
            </div>
        </div>
    );
};
